import React, { useContext, useEffect, useRef, useState } from "react";
import { connect } from 'react-redux'
import Switch from "../../../components/Switch";
import DraftHTML from "../../../components/draftEditor/export/DraftHTML";
import styles from './FeatureLayout.module.scss';
import Link from "next/link";
import { CardContext } from "../../../components/card/CardAdvanced";

function FeatureLayout({
                           layoutDimensions,
                           feature, plan,
                           onChange, enabled,
                           showSettings, onSettingsClick
                       }) {


    const cardContext = useContext(CardContext);

    const description = useRef();

    const [collapsed, setCollapsed] = useState(true);
    const [height, setHeight] = useState(undefined);


    useEffect(() => {
        setHeight(description?.current?.offsetHeight || undefined);
    }, []);

    useEffect(() => {
        if (!collapsed) {
            setHeight(description?.current?.offsetHeight || undefined);
        }
    }, [layoutDimensions.height, layoutDimensions.width, collapsed])


    const renderTitle = () => {

        const {name, type, suggested, linkExplain} = feature;
        let requiresUpgrade = null;

        if (!plan?.supportedFeatures?.includes(type)) requiresUpgrade = <i className='fas fa-shopping-cart'/>;

        return (
            <div className={styles['feature-head']}>
                <div className={styles['feature-title']}>
                    <div className={styles['feature-title__text']}>{name}</div>
                    {
                        !!suggested &&
                        <div className={styles['feature-title__suggested']} title='Suggested'>
                            <i className='fas fa-star'/>
                        </div>
                    }
                    {
                        !!requiresUpgrade &&
                        <div className={styles['feature-title__upgrade']} title='Requires plan upgrade'>
                            {requiresUpgrade}
                        </div>
                    }
                </div>
                {
                    !!linkExplain &&
                    <div className={styles['feature-link']}>
                        <div className={styles['feature-link__icon']}>
                            <i className='fas fa-question-circle'/>
                        </div>
                        {
                            linkExplain.url.charAt(0) === '/'
                                ?
                                <Link
                                    href={linkExplain.url}
                                    target='_blank'
                                    rel={!linkExplain.follow ? 'nofollow' : undefined}
                                    onClick={e => e.stopPropagation()}
                                    className={styles['feature-link__link']}>

                                    {linkExplain.title ? linkExplain.title : 'Learn more about this app'}

                                </Link>
                                :
                                <a
                                    onClick={e => e.stopPropagation()}
                                    className={styles['feature-link__link']}
                                    href={linkExplain.url}
                                    rel={!linkExplain.follow ? 'nofollow' : undefined}
                                    target='_blank'
                                >
                                    {linkExplain.title ? linkExplain.title : 'Learn more about this app'}
                                </a>
                        }
                    </div>
                }
            </div>
        );
    }

    const renderDescription = () => {

        return (
            <div
                className={styles['description']}
                onClick={e => {
                    e.stopPropagation();
                    if (!!collapsed) setCollapsed(false);
                    cardContext?.calculateHeight(200);
                }}
            >
                <div
                    className={styles['description__trigger']}
                    onClick={!collapsed ? () => setCollapsed(true) : () => {}}
                >
                    <i className={`fas fa-chevron-down ${styles['description__trigger__icon']}`}/>
                </div>
                <div className={styles['description__container']}>
                    <div
                        className={styles['description__container__content']}
                        ref={description}
                    >
                        {
                            typeof feature.description !== 'string' ?
                                <DraftHTML
                                    className={styles['feature-draft']}
                                    content={feature.description}
                                    styles={{'unstyled': styles['feature-draft__unstyled']}}
                                />
                                : <div className={styles['description__container__content__string']}>
                                    {feature.description}
                                </div>
                        }
                    </div>
                </div>
            </div>
        )
    }


    const collapse = !collapsed ? ` ${styles['feature--show-description']}` : '';

    return (
        <div
            className={`${styles['feature']}${collapse}`}
            style={{'--contentHeight': !!collapsed ? '2.2rem' : height / 10 + 'rem'}}
        >
            <div className={styles['feature__content']}>
                <Switch
                    className={styles['feature__content__switch']}
                    title={renderTitle()}
                    onChange={() => onChange(feature)}
                    value={enabled}
                    description={!!feature.description && renderDescription()}
                    showSettings={showSettings}
                    onSettingsClick={() => onSettingsClick(feature)}
                />
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    layoutDimensions: state.UI.layoutDimensions,
})

export default connect(mapStateToProps)(FeatureLayout)